import React, { useState } from 'react';
import RankingsOverlay from './RankingsOverlay';

export default function RankingsButton(props) {
    const [toggled, setToggled] = useState(false);

    function toggle() {
        setToggled(!toggled);
    }

    return (
        <>
            <div className="xs_rankingsButton h-full w-full flex items-center justify-center" onClick={toggle}>
                <i className="mx-2 xs-font-icon bi-list-ol" />
            </div>
            {toggled &&
                <RankingsOverlay classifica={props.classifica} sportId={props.sportId} toggle={toggle} />
            }
        </>
    );
}
